import styled from 'styled-components'
import { NODE_WIDTH } from '../constants';

const BoardRow = styled.div`
  height: ${NODE_WIDTH}em;
`

export default BoardRow
